import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { Button, Card, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { FaShoppingCart, FaFacebook, FaTwitter, FaPlus, FaMinus } from "react-icons/fa"
import { addToCart } from '../../actions/cartActions'

import './publicationInfoCard.css';

const PublicationInfoCard = (props) => {

    const dispatch = useDispatch()

    const { publications } = useSelector(state => state.all)

    const { id } = useParams()
    const singlePublication = publications && publications.find(item => item._id === id)

    const [quantity, setQuantity] = useState(1)

    const handleCart = () => {
        singlePublication.quantity = quantity
        dispatch(addToCart(singlePublication))
    }

    const increaseQty = () => {
        setQuantity((qty) => qty + 1)
    }

    const decreaseQty = () => {
        setQuantity((qty) => {
            if(qty > 0) {
                return (qty - 1);
            }
            return 0;
        })
    }

    return (
        publications && publications.length > 0 && singlePublication ? (
            <Card className="publication-info-card border-0">
                <Card.Body>
                    <span className='text-secondary mb-4 d-inline-block' style={{ fontSize: 18 }}>পাবলিকেশন</span>
                    <Card.Title>{singlePublication.title}</Card.Title>

                    <Card.Text>
                        {singlePublication.description}
                    </Card.Text>

                    <hr />

                    <span className='font-weight-bold'>
                        <span className='mr-1'>মূল্যঃ </span>
                        { singlePublication.discount !== 0 && <del className='text-danger mr-2'>{singlePublication.price}</del>}
                        { singlePublication.price > 0 ? `${singlePublication.price - singlePublication.discount} টাকা` : 'ফ্রি' }
                    </span>
                    <hr />
                    <span className='font-weight-bold'>
                        <span className='mr-1'>ক্যাটাগরিঃ </span>
                        {singlePublication.categories.map((item, index, arr) => {
                            if (index !== arr.length - 1) {
                                return <span key={`link_${index + 1}`}> <Link to={`/publications/${item.name}`} className="text-muted">{item.name}</Link>,</span>
                            }
                            return <span key={`link_${index + 1}`}> <Link to={`/publications/${item.name}`} className="text-muted">{item.name}</Link></span>
                        })}
                    </span>
                    {/* <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between">
                        <ul className="list-inline mb-2 mb-sm-0">
                            { singlePublication.discount !== 0 && <li className="list-inline-item h4 text-muted "><del>{singlePublication.price}</del></li> }
                            { singlePublication.price > 0 ? <li className="list-inline-item h2  mb-0">{singlePublication.price - singlePublication.discount} টাকা</li> : <li className="list-inline-item h2  mb-0">Free</li> }
                        </ul>
                    </div> */}
                    <hr />
                    <Form className="mt-4">
                        <div className="d-inline-flex aling-items-center">
                            <span className='flex-shrink-0 font-weight-bold mr-2'>পরিমাণঃ</span>
                            <Button className='mr-2' variant="outline-secondary" onClick={() => decreaseQty()} size="sm">
                                <FaMinus />
                            </Button >
                            <Form.Control name="items" type="number" className="detail-quantity form-control-sm" min="1" value={quantity} onChange={e => setQuantity(e.target.value)} />
                            <Button className='ml-2' variant="outline-secondary" onClick={() => increaseQty()} size="sm">
                                <FaPlus />
                            </Button >
                        </div>
                        <hr />
                        <Form.Group as={Row} className="row mt-4">
                            <Col xs={12}>
                                <Button
                                    className="add-to-cart"
                                    onClick={handleCart}
                                    disabled={(quantity <= 0)}
                                    block
                                >
                                    <FaShoppingCart className="mr-2" />
                                    Add to Cart
                                </Button>
                            </Col>
                        </Form.Group>
                    </Form>
                </Card.Body>
            </Card>
        ) : null
    )
}

export default PublicationInfoCard;